module.exports = __webpack_public_path__ + "static/media/partner3.8925f586.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/partner3.png
// module id = 1099
// module chunks = 21